import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { theme } from '@garnish/constants';
import { useA11ySelector } from '@sg/a11y-helpers';
import { useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutFormContainer = (props: ViewProps) => {
  const a11ySelector = useA11ySelector('gift-cards.customization.container');

  const { match } = useResponsive();

  const formContainerStyles = [
    styles.formContainer,
    match([
      styles.formContainerContainerXS,
      styles.formContainerContainerSM,
      styles.formContainerContainerMD,
    ]),
    props.style,
  ];

  return (
    <View style={formContainerStyles} {...a11ySelector.props}>
      {props.children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  formContainer: {
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    rowGap: theme.spacing['2'],
  },
  formContainerContainerXS: {
    marginTop: theme.spacing['10'],
    borderTopWidth: 1,
    borderTopColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    paddingBottom: theme.spacing['2'],
  },
  formContainerContainerSM: {
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    borderRadius: theme.radius.large,
    marginTop: theme.spacing['10'],
  },
  formContainerContainerMD: {
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    borderRadius: theme.radius.large,
  },
});
